const sessionKeys = {
  ugcTermsConditionsAccepted: 'ugc-terms-condition',
  ugcContactDetailsFilled: 'contact-details',
  ugcOptIn: 'opt-in',
  splashPageShown: 'splash-page',
  graphicEditorSplashPageShown: 'graphic-editor-splash-page',
  checkerfyIntroSkip: 'checkerfyIntroSkip',
  ugcIntroVideos: 'ugc-intro-videos'
};

const themePalette = {
  themePrefix: 'palette-theme-'
}

const fabricCanvasHeight = {
  vertical: {
    "default": "15em",
    "medium": "18em",
    "large": "23em",
    "xlarge": "27em"
  }
}

const paletteHiddenFeatures = {
  SHARE: 'share',
  TRANSFER_DESIGN: 'transferDesign'
}

const subgroupFeatures = {
  'checkerboard-creator': 'patternMaker',
  'ugc': 'ugc',
  'custom-checkerboard': 'customCheckerboard',
  'library': 'imageLibrary'
}

const decoStitch = 'deco-stitch';
const randomize = 'Randomize';

const recaptchaHost = "https://www.google.com/recaptcha/api2";

export {
  sessionKeys,
  themePalette,
  fabricCanvasHeight,
  paletteHiddenFeatures,
  decoStitch,
  randomize,
  subgroupFeatures,
  recaptchaHost
}
